import { useTranslation } from 'react-i18next'

export function useLanguage() {
  const { i18n } = useTranslation()

  const currentLanguage = i18n.language
  const isZhCN = currentLanguage === 'zh-CN'
  const isEn = currentLanguage === 'en'

  const applyLanguage = (lang: string) => {
    i18n.changeLanguage(lang)
    localStorage.setItem('myaigc-language', lang)
    document.documentElement.lang = lang
    document.title = i18n.t('common:siteTitle')
  }

  const toggleLanguage = () => {
    const nextLang = isZhCN ? 'en' : 'zh-CN'
    applyLanguage(nextLang)
  }

  const setLanguage = (lang: string) => {
    applyLanguage(lang)
  }

  return {
    currentLanguage,
    isZhCN,
    isEn,
    toggleLanguage,
    setLanguage,
  }
}
